
export { TextStyles } from "./src/Text/Text.Styled"